import { Type } from 'class-transformer';
import { ModelWithAttachments } from './attachment';
import { User } from './user';
import { EmailTemplateFolder } from './email_template_folder';

export interface EmailTemplatePreview {
  content: string | null;

  error: string | null;
}

export class EmailTemplate extends ModelWithAttachments {
  @Type(() => User)
  author: User | null;

  author_id: string;

  body: string | null;

  cc: string[];

  reply_to: string[];

  is_default: boolean;

  name: string;

  subject: string | null;

  auto_correct: boolean;

  @Type(() => EmailTemplateFolder)
  folder: EmailTemplateFolder | null;

  folder_id: string | null;

  preview_subject: EmailTemplatePreview;

  preview_body: EmailTemplatePreview;
}

export interface EmailTemplateVariable {
  name: string;

  display_name: string;

  jinja: string;
}
